export default "__VITE_ASSET__3a45a4ba__"